import { FieldShell } from './FieldShell';
import { useFieldName, useDomFieldId } from './_useFieldName';
import { FIELD_AUTOCOMPLETE_OFF } from './_fieldDefaults';

const BLOCK = 'LStudio__app_field';

export const FieldNumber = ({
    id, name, label, hint, error,
    value = '', onChange, onBlur = null,
    min = 0, max = null, step = 1,
    allowNegative = false, allowDecimal = false,
    placeholder = '0',
    isRequired = false, isDisabled = false, isReadOnly = false,
    span = 1, onKeyDown = null, ...rest
}) => {
    const DOM_ID = useDomFieldId(id);
    const { domName, onChangeField, onBlurField } = useFieldName({ id, name, onChange, onBlur, isEnabled: true });

    const onHandleKeyDown = (event) => {
        if (!allowNegative && (event.key === '-' || event.key === '+')) event.preventDefault();
        if (!allowDecimal && ['.', ','].includes(event.key)) event.preventDefault();
        if (['e', 'E'].includes(event.key)) event.preventDefault();
        onKeyDown?.(event);
    };

    const onHandleChange = (event) => {
        const raw = event.target.value;
        if (raw === '') return onChangeField(event);

        const numeric = Number(raw);
        if (!Number.isFinite(numeric)) return;
        if (!allowNegative && numeric < 0) return;
        if (min !== null && min !== undefined && numeric < Number(min)) return;
        if (max !== null && max !== undefined && numeric > Number(max)) return;

        const nextValue = allowDecimal ? raw : String(Math.trunc(numeric));
        onChangeField({
            target: { ...event.target, value: nextValue, type: 'number', checked: false },
            preventDefault: () => event.preventDefault(),
            stopPropagation: () => event.stopPropagation(),
        });
    };

    return (
        <FieldShell id={DOM_ID} label={label} hint={hint} error={error}
            isRequired={isRequired} isDisabled={isDisabled} span={span}>
            <input
                id={DOM_ID}
                data-field={name ?? id}
                name={domName}
                type="number"
                className={`${BLOCK}__input`}
                value={value ?? ''}
                onChange={onHandleChange}
                onBlur={onBlurField}
                onKeyDown={onHandleKeyDown}
                min={min ?? undefined}
                max={max ?? undefined}
                step={allowDecimal ? (step ?? 'any') : (step ?? 1)}
                placeholder={placeholder}
                required={isRequired}
                disabled={isDisabled}
                readOnly={isReadOnly}
                autoComplete={FIELD_AUTOCOMPLETE_OFF}
                aria-invalid={!!error}
                {...rest}
            />
        </FieldShell>
    );
};
